import { useCallback, useEffect, useState } from "react";

export const generalHighlightNurseId = (nurseId: number, action: "highlight" | "clear" | "clearAll") => {
	window.dispatchEvent(
		new CustomEvent<{
			nurseId: number;
			action: "highlight" | "clear" | "clearAll";
		}>("nurseHighlighted", { detail: { nurseId, action } }),
	);
};

export const useNurseHighlight = (nurseId: number) => {
	const [isNurseIdHighlighted, setIsNurseIdHighlighted] = useState(false);

	useEffect(() => {
		interface NurseHighlightEvent extends CustomEvent {
			detail: {
				nurseId: number;
				action: "highlight" | "clear" | "clearAll";
			};
		}

		const handleHighlight = (e: NurseHighlightEvent) => {
			if (e.detail.action === "highlight") {
				setIsNurseIdHighlighted(e.detail.nurseId === nurseId);
			} else if (e.detail.action === "clear" && e.detail.nurseId === nurseId) {
				setIsNurseIdHighlighted(false);
			}
		};

		window.addEventListener("nurseHighlighted", handleHighlight as EventListener);
		return () => window.removeEventListener("nurseHighlighted", handleHighlight as EventListener);
	}, [nurseId]);

	return { isNurseIdHighlighted };
};

export const highlightNurseId = (nurseId: number) => {
	window.dispatchEvent(
		new CustomEvent<{ nurseId: number; action: string }>("nurseHighlighted", {
			detail: {
				nurseId,
				action: "highlight",
			},
		}),
	);
};

export const clearNurseHighlight = (nurseId: number) => {
	window.dispatchEvent(
		new CustomEvent<{ nurseId: number; action: string }>("nurseHighlighted", {
			detail: {
				nurseId,
				action: "clear",
			},
		}),
	);
};
